import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link,
  NavLink,
  useLocation,
  useParams,
  withRouter,
} from 'react-router-dom';

import jwt from 'jsonwebtoken';
import Swal from 'sweetalert2';
import Clock from 'react-live-clock';
import {
  Drawer,
  makeStyles,
  Button,
  ListItemText,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  Typography,
  CardMedia,
  ClickAwayListener,
  Grid,
} from '@material-ui/core';

// import GamificationPopup from '../../../../components/Gamification/GamificationPopup';
import { useSharedState } from '../../../../StoreContext';
import { getUserNotifications } from '../../../../actions/settings/notifications-actions';
import { getUser } from '../../../../actions/users/co-user-actions';
import Notification from '../../../../components/Notification';
import ComingSoon from '../../../../images/comingSoon.png';
import {
  // TutorialIcon,
  TorqueLogoOpen,
  AddNewActivity,
  SignOutIcon,
  CloseSidebar,
  ThreeBars,
  TimeIcon,
  DashboardInactive,
  SettingsActive,
  DashboardIcon6,
  DashboardIcon1,
  AppointmentIcon,
  AppointmentFilled,
  JobBoardFilled,
  JobBoardIcon,
  ReportIcon,
  DashboardIcon4,
  PurchasesActive,
  Purchases,
  ListingActive,
  DashboardIcon3,
} from '../../../../constants';

import './NavbarRes.scss';

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  admin__details: {
    position: 'absolute',
    bottom: '0',
    width: '100%',
  },
  primary__text: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#fff',
  },
  secondary__text: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '24px',
    color: '#E7ECF4',
  },
  cursor__pointer: {
    cursor: 'pointer',
  },
  hr__color: {
    backgroundColor: 'rgba(236, 236, 238, 0.35)',
  },
  root: {
    width: '30rem',
    position: 'absolute',
    zIndex: '999',
    top: '70px',
    right: '0',
    boxShadow: '0 8px 30px rgba(161, 191, 218, 0.16)',
    padding: '25px 0',
    borderRadius: '15px',
    background: '#fff',
    [theme.breakpoints.down('sm')]: {
      width: '30rem',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
      right: '-3.5rem',
    },
  },
  notification__ul: {
    maxHeight: '35vh',
    overflowY: 'scroll',
    [theme.breakpoints.down('xs')]: {
      maxHeight: '45vh',
    },
  },

  notification__title: {
    fontWeight: 'bold',
    fontSize: '24px',
    linHeight: '29px',
    color: '#171717',
    padding: '0.5rem 1.5rem',
  },
  primary__text__noti: {
    color: '#29264A',
    fontSize: '13px',
    lineHeight: '14px',
  },
  secondary__text__noti: {
    color: '#95989A',
    fontSize: '11px',
    lineHeight: '16px',
    width: '70%',
    paddingTop: '0.3rem',
  },

  avatar__size: {
    height: '54px',
    width: '54px',
    marginRight: '0.7rem',
    [theme.breakpoints.down('xs')]: {
      height: '44px',
      width: '44px',
    },
  },
  listItem__spacing: {
    padding: '0.6rem 25px',
    background: 'rgba(105, 33, 196, 0.1)',
    '&:hover': {
      background: 'rgba(105, 33, 196, 0.2)',
    },
  },
  mechanic__photo: {
    borderRadius: '100px',
    width: '40px',
    height: '40px',
    marginRight: '0.5rem',
  },
  background__highlight: {
    background: 'rgba(105, 33, 196, 0)',
    '&:hover': {
      background: 'rgba(236, 236, 238, 0.5)',
    },
  },
  digi__clock: {
    margin: '0',
    background: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '10px',
    padding: '.8rem',
    width: '96%',
  },
  time: {
    fontSize: '15px',
    fontWeight: '400',
    color: '#fff',
    width: '100%',
    textAlign: 'center',
  },
  day: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff',
    width: '100%',
    textAlign: 'center',
    padding: '1rem 0 .5rem 0',
  },
  icon: {
    width: '100%',
  },
  pos__rel: {
    position: 'relative',
  },
}));

const NavbarRes = ({
  repairOrderId,
  quichcheckoutPermission,
  isAllowedQC,
  appointmentPermission,
  jobBoardPermission,
  isAllowedReports,
  reportsPermission,
  isAllowedPurchases,
  poPermission,
  listingPermission,
}) => {
  const dispatch = useDispatch();
  const { userData: userDataa } = useSelector((st) => st.coUser);
  const { id } = useParams();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [generalInfo, setGeneralInfo] = useState({
    name: '',
    userName: '',
    storeAddress: '',
  });
  const [dropdown, setDropdown] = useState(false);
  // const [tutorial, setTutorial] = useState(false);
  const [coming, setComing] = useState(false);

  // const handleTutorialOpen = () => {
  //   setDropdown(false);
  //   setTutorial(true);
  // };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/signin';
  };

  // const state = useContext(StateContext);
  const [state] = useSharedState();
  const setHeader = state?.layout?.setHeader || '';
  const { pathname } = useLocation();
  const userData = JSON.parse(localStorage.getItem('userData'));
  const { token } = userData;
  const tokenData = jwt.decode(token);
  useEffect(() => {
    const StoreName = userData.userStore?.businessName;
    const StoreAddress = userData.userStore?.address;
    setGeneralInfo({
      name: StoreName,
      userName: tokenData.name,
      storeAddress: StoreAddress,
    });
  }, []);

  useEffect(() => {
    if (!userData?.userStore) return; // call api's only if user store exists

    const promises = [];
    // if redux does't contain user details then call get user api
    if (!userData?.name) {
      promises.push(dispatch(getUser()));
    }
    promises.push(dispatch(getUserNotifications()));

    Promise.all(promises);
  }, []);

  return (
    <>
      <div className='NavbarRes'>
        <p className='heading'>
          {setHeader?.title}
          <br />
          {repairOrderId && 'RO-' + repairOrderId}
        </p>
        <div className='navbarActions'>
          <div className={classes.pos__rel}>
            <AddNewActivity
              className='addNewActivity'
              onClick={() => setDropdown(true)}
            />
            {dropdown && (
              <ClickAwayListener onClickAway={() => setDropdown(!dropdown)}>
                <Grid className='root__dropdown__main__screen' conatiner>
                  {/* <Divider /> */}
                  {isAllowedQC && quichcheckoutPermission && (
                    <Link to='/quickcheckout'>
                      <Typography
                        className='dropdown__menu__text'
                        onClick={() => setDropdown(!dropdown)}
                      >
                        Quick Checkout
                      </Typography>
                    </Link>
                  )}

                  {/* <Divider />
                  <Typography
                    className='dropdown__menu__text'
                    onClick={handleTutorialOpen}
                  >
                    Tutorials
                  </Typography> */}
                </Grid>
              </ClickAwayListener>
            )}
          </div>

          {/* <GamificationPopup toggle={tutorial} setToggle={setTutorial} /> */}

          <div className='notification'>
            <Notification />
          </div>
          <ThreeBars onClick={handleDrawerOpen} className='threeBars' />
        </div>
      </div>
      <Drawer
        className={`NavbarDrawer ${classes.drawer}`}
        variant='persistent'
        anchor='right'
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className='LogoClose'>
          <Link to='/dashboard'>
            <TorqueLogoOpen />
          </Link>
          <CloseSidebar
            className={classes.cursor__pointer}
            onClick={handleDrawerClose}
          />
        </div>
        <div className='nameInfo'>
          <p className='name'>{generalInfo.name}</p>
          <p className='address'>{generalInfo.storeAddress}</p>

          <div className={classes.digi__clock}>
            <TimeIcon className={classes.icon} />
            <Typography className={classes.day}>
              <Clock format='dddd' ticking='true' />
            </Typography>
            <Typography className={classes.time}>
              <Clock format='HH:mm' ticking='true' />
            </Typography>
          </div>
        </div>
        <div className='actions'>
          {(pathname === `/new-repairorder/${id}` ||
            pathname === '/settings') && (
            <>
              <NavLink
                to='/'
                variant='contained'
                color='secondary'
                className='SettingBtn'
                // onClick={comingSoon}
              >
                {pathname === '/dashboard' ? (
                  <DashboardIcon1 />
                ) : (
                  <DashboardInactive />
                )}
                &nbsp; Dashboard
              </NavLink>
              {appointmentPermission && (
                <NavLink
                  to='/appointments'
                  variant='contained'
                  color='secondary'
                  className='SettingBtn'
                  // onClick={comingSoon}
                >
                  {pathname === '/appointments' ? (
                    <AppointmentFilled />
                  ) : (
                    <AppointmentIcon />
                  )}
                  &nbsp; Appointment
                </NavLink>
              )}

              {jobBoardPermission && (
                <NavLink
                  to='/jobboard'
                  variant='contained'
                  color='secondary'
                  className='SettingBtn'
                  // onClick={comingSoon}
                >
                  {pathname === '/jobboard' ? (
                    <JobBoardFilled />
                  ) : (
                    <JobBoardIcon />
                  )}
                  &nbsp; Job Board
                </NavLink>
              )}

              {isAllowedReports && reportsPermission && (
                <NavLink
                  to='/reports'
                  variant='contained'
                  color='secondary'
                  className='SettingBtn'
                  // onClick={comingSoon}
                >
                  {pathname === '/reports' ? (
                    <ReportIcon />
                  ) : (
                    <DashboardIcon4 />
                  )}
                  &nbsp; Reports
                </NavLink>
              )}

              {isAllowedPurchases && poPermission && (
                <NavLink
                  to='/purchases'
                  variant='contained'
                  color='secondary'
                  className='SettingBtn'
                  // onClick={comingSoon}
                >
                  {pathname === '/purchases' ? (
                    <PurchasesActive />
                  ) : (
                    <Purchases />
                  )}
                  &nbsp; Purchases
                </NavLink>
              )}

              {listingPermission && (
                <NavLink
                  to='/listing'
                  variant='contained'
                  color='secondary'
                  className='SettingBtn'
                  // onClick={comingSoon}
                >
                  {pathname === '/listing' ? (
                    <ListingActive />
                  ) : (
                    <DashboardIcon3 />
                  )}
                  &nbsp; Lists
                </NavLink>
              )}
            </>
          )}
          <NavLink
            to='/settings'
            variant='contained'
            color='secondary'
            className='SettingBtn'
            // onClick={comingSoon}
          >
            {pathname === '/settings' ? <SettingsActive /> : <DashboardIcon6 />}{' '}
            &nbsp; Settings
          </NavLink>
          {/* <Button
            variant='contained'
            color='secondary'
            className='SettingBtn'
            onClick={openTutorial}
          >
            <TutorialIcon /> &nbsp; Tutorial
          </Button>
           */}
          <Button
            // to='/settings'
            variant='contained'
            color='secondary'
            className='SettingBtn'
            onClick={handleLogout}
          >
            <SignOutIcon /> &nbsp; Sign Out
          </Button>
        </div>
        <div className={classes.admin__details}>
          <Divider className={classes.hr__color} />
          <List
            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          >
            <ListItem>
              {userDataa?.accountProfileImage ? (
                <CardMedia
                  className={classes.mechanic__photo}
                  image={userDataa?.accountProfileImage}
                />
              ) : (
                <ListItemAvatar className={classes.mechanic__photo}>
                  <Avatar alt='new' />
                </ListItemAvatar>
              )}
              <ListItemText
                primary={
                  generalInfo.userName ? generalInfo.userName : 'John Doe'
                }
                // secondary='Admin'
                classes={{
                  primary: classes.primary__text,
                  secondary: classes.secondary__text,
                }}
              />
            </ListItem>
          </List>
        </div>
        {coming && (
          <div>
            {Swal.fire({
              // icon: { comingSoonImg },
              // iconHtml: `<img src=${ComingSoon}>`,
              imageUrl: `${ComingSoon}`,
              imageHeight: 60,
              imageWidth: 60,
              imageAlt: 'A tall image',
              title: 'Coming Soon!',
              text: 'This feature will be available soon',
              confirmButtonText: 'OK',
              customClass: {
                container: 'inspection__right__alert__swal',
                popup: 'CustomizeSwalPopup',
                icon: 'CustomizeSwalIcon',
                title: 'CustomizeSwalTitle',
                text: 'CustomizeSwalText',
                confirmButton: 'CustomizeSwalConfirmButton',
              },
            }).then(setComing(false))}
          </div>
        )}
      </Drawer>
    </>
  );
};

export default withRouter(NavbarRes);
